module.exports = __webpack_public_path__ + "media/images/Branding/HW Red 1-ac7af3ca750e802dd03fc31f3048ce55.png";